import { render, staticRenderFns } from "./desc.vue?vue&type=template&id=6a52c1e5&scoped=true&"
import script from "./desc.vue?vue&type=script&lang=js&"
export * from "./desc.vue?vue&type=script&lang=js&"
import style0 from "./desc.vue?vue&type=style&index=0&id=6a52c1e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a52c1e5",
  null
  
)

component.options.__file = "desc.vue"
export default component.exports